const Endpoints = {
    // Authentication
    login: "/admin/auth/login",
    updateProfile: "/admin/auth/update-profile",
    refreshToken: "/admin/auth/refresh-token",

    // User
    user: "/admin/user",
    sendCredentials: "/admin/user/send-invitation",

    // Product
    product: "/admin/product",
    allProducts: "/admin/product/all",

    // Order
    order: "/admin/order",

    // Upload
    upload: "/upload",

    // Config
    config: "/admin/config",

    // Card
    card: "/admin/card",

    // Dashboard
    dashboard: "/admin/dashboard",
    dashboardCardStats: "/admin/dashboard/card-stats",
    dashboardCardSalesByType: "/admin/dashboard/card-sales-by-type",
    dashboardOrdersByStatus: "/admin/dashboard/orders-by-status",
    dashboardCardSales: "/admin/dashboard/card-sales",
    dashboardCardSalesType: "/admin/dashboard/card-sales-type",
};

export default Endpoints;
